export default {
  会议时间: 'Date/Time',
  会议赞助: 'Become Sponsor Now',
  会议简介: 'Event Introduction',
  参会嘉宾: 'Guests',
  会议日程: 'Event Agenda',
  会议地点: 'Venue',
  会场信息: 'Event Introduction',
  会场地点: 'Venue',
  会场地址: 'Venue Address',
  会议门票: 'Admission Ticket',
  赞助商列表: 'Sponsor List',
  会议赞助申请: 'Apply for Conference Sponsorship',
  报名参加: 'Sign up Now',
  会议报名: 'Meeting registration',
  立即报名: 'Sign up Now',
  立即申请: 'Apply Now',
  该会议已下架: 'Conference removed.',
  该会议不存在: 'Conference doesn’t exist.',
  以下赞助名单排名不分前后: 'The following sponsors are listed in no particular order.',
}
